<template>
  <el-dialog
    :title="$t('chooseApp.selectApp')"
    :visible.sync="dialogVisible"
    width="70%"
    @close="handleClose"
  >
    <el-row :gutter="20">
      <el-col :span="24">
        <el-input-group>
          <el-input
            v-model="chooseAppInfo._currentAppName"
            :placeholder="$t('chooseApp.inputAppName')"
          ></el-input>
          <el-button-group slot="append">
            <el-button type="primary" @click="queryApps()">
              {{ $t('chooseApp.query') }}
            </el-button>
          </el-button-group>
        </el-input-group>
      </el-col>
    </el-row>

    <el-table :data="chooseAppInfo.apps" border style="width: 100%; margin-top: 15px">
      <el-table-column
        prop="appId"
        :label="$t('chooseApp.appId')"
      ></el-table-column>
      <el-table-column
        prop="name"
        :label="$t('chooseApp.appName')"
      ></el-table-column>
      <el-table-column :label="$t('chooseApp.operation')" width="120">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="chooseApp(scope.row)"
          >
            {{ $t('chooseApp.select') }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="pageSize"
      layout="total, prev, pager, next"
      :total="total"
    ></el-pagination>
  </el-dialog>
</template>

<script>
import { listApps } from '@/api/dev/serviceRegisterApi'

export default {
  name: 'ChooseApp',
  data() {
    return {
      dialogVisible: false,
      chooseAppInfo: {
        apps: [],
        _currentAppName: ''
      },
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this._refreshChooseAppInfo()
      this._loadAllAppInfo(1, 10, '')
    },
    async _loadAllAppInfo(page, row, name) {
      try {
        const params = {
          page,
          row,
          name
        }
        const res = await listApps(params)
        this.chooseAppInfo.apps = res.data
        this.total = res.records
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    chooseApp(app) {
      app.appName = app.name
      this.$emit('chooseApp', app)
      this.dialogVisible = false
    },
    queryApps() {
      this._loadAllAppInfo(1, 10, this.chooseAppInfo._currentAppName)
    },
    _refreshChooseAppInfo() {
      this.chooseAppInfo._currentAppName = ''
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this._loadAllAppInfo(this.currentPage, this.pageSize)
    },
    handleClose() {
      this._refreshChooseAppInfo()
    }
  }
}
</script>

<style scoped>
.el-row {
  width: 100%;
}
.el-col {
  width: 100%;
}
</style>